<template>
  <v-list class="nav-menu-list">
    <slot />
  </v-list>
</template>

<style scoped lang="scss">
@import "~/assets/styles/variables";

.nav-menu-list {
  &:deep(.v-list-item) {
    padding-inline-start: 1rem !important;

    &:not([id^=v-list-group]) {
      & > .v-list-item__overlay {
        --v-activated-opacity: 0;
        --v-hover-opacity: 0.075;
        background-color: $navigation-menu-list-item-active-color;
      }

      & > .v-ripple__container {
        color: $navigation-menu-list-item-ripple-color;
      }

      &.v-list-item--active {
        box-shadow: inset 4px 0 $navigation-menu-list-item-active-color;
      }
    }

    &[id^=v-list-group] {
      color: $navigation-menu-list-group-toggle-color;
    }
  }

  &:deep(.v-list-group):not(:first-child) {
    border-top: 1px solid $navigation-menu-divider-color;
  }
}
</style>
